import { render } from "./pagarreserva.vue?vue&type=template&id=0fbfe14b&scoped=true"
import script from "./pagarreserva.vue?vue&type=script&lang=js"
export * from "./pagarreserva.vue?vue&type=script&lang=js"

import "./pagarreserva.vue?vue&type=style&index=0&id=0fbfe14b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbfe14b"]])

export default __exports__